/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpToLine: {
  name: 'arrow-up-to-line';
  data: string;
} = {
  name: 'arrow-up-to-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a1 1 0 0 0 0 2h5a.997.997 0 0 0-.707.293l-4 4a1 1 0 1 0 1.414 1.414L11 9.414V19a1 1 0 1 0 2 0V9.414l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4A.997.997 0 0 0 12.001 6H17a1 1 0 1 0 0-2H7Z" fill="currentColor"/></svg>`,
};
